import { EditorFieldType } from '../../../common/formly/editor.formly';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InvoiceRoutingModule } from './invoice-routing.module';
import { AllInvoicesComponent } from './components/all-invoices/all-invoices.component';
import { InvoiceDetailsComponent } from './components/invoice-details/invoice-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { InvoiceEditComponent } from './components/invoice-edit/invoice-edit.component';
import { InputTextModule } from 'primeng/inputtext';
import { SharedModule } from 'src/app/common/modules/shared/shared.module';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { NgxPrinterModule } from 'ngx-printer';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MenuModule } from 'primeng/menu';
import { TagModule } from 'primeng/tag';
import { MultiSelectModule } from 'primeng/multiselect';
import { EBMSuiteSharedModule } from '../ebmsuite-shared/ebmsuite-shared.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { ReceiptFooterComponent } from '../ebmsuite-shared/components/receipt-footer/receipt-footer.component';
import { AvatarModule } from 'primeng/avatar';
import { TransactionCreateComponent } from '../transactions/transaction-create/transaction-create.component';
import { CalendarModule } from 'primeng/calendar';
import { LicenseLimitBannerComponent } from 'src/app/common/modules/license/components/license-limit-banner/license-limit-banner.component';
import { TimelineModule } from 'primeng/timeline';
import { PermissionDirective } from 'src/app/common/directives/permission/permission.directive';

@NgModule({
  declarations: [AllInvoicesComponent, InvoiceDetailsComponent, InvoiceEditComponent],
  exports: [AllInvoicesComponent, InvoiceDetailsComponent],
  imports: [
    CommonModule,
    InvoiceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule.forRoot({
      validationMessages: [{ name: 'required', message: 'This field is required' }],
      types: [{ name: 'editor', component: EditorFieldType }]
    }),
    FormlyPrimeNGModule,
    PaginatorModule,
    TableModule,
    InputTextModule,
    SharedModule,
    ButtonModule,
    SplitButtonModule,
    DynamicDialogModule,
    ToastModule,
    InputTextareaModule,
    AutoCompleteModule,
    NgxPrinterModule.forRoot({ printOpenWindow: false }),
    DialogModule,
    MessageModule,
    MessagesModule,
    InputSwitchModule,
    MenuModule,
    TagModule,
    MultiSelectModule,
    EBMSuiteSharedModule,
    ConfirmDialogModule,
    DropdownModule,
    AvatarModule,
    CalendarModule,
    ReceiptFooterComponent,
    TransactionCreateComponent,
    LicenseLimitBannerComponent,
    TimelineModule,
    PermissionDirective
  ]
})
export class InvoiceModule {}
